import React from 'react';

/**
 * Малюнки до переваг.
 *
 * Той самий прийом, що й у ServiceGlyph і SituationGlyph: лінійні малюнки
 * просто в розмітці, без файлів і мережевих запитів, колір із тексту.
 * П'ять переваг — п'ять малюнків, кожен про свою думку, а не «галочка»
 * п'ять разів поспіль, як було в попередній редакції.
 */

const Frame = ({ children, className }) => (
  <svg
    viewBox="0 0 64 64"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

// 01. Одна спеціалізація — приціл: фокус на одному.
const Focus = () => (
  <>
    <circle cx="32" cy="32" r="20" />
    <circle cx="32" cy="32" r="8" />
    <path d="M32 4v10M32 50v10M4 32h10M50 32h10" />
    <circle cx="32" cy="32" r="1.6" fill="currentColor" stroke="none" />
  </>
);

// 02. Усі напрямки одразу — ланцюг: ланки зчеплені, а не лежать поруч.
const Chain = () => (
  <>
    <rect x="5" y="25" width="22" height="14" rx="7" />
    <rect x="21" y="25" width="22" height="14" rx="7" />
    <rect x="37" y="25" width="22" height="14" rx="7" />
  </>
);

// 03. Партнери в суміжних галузях — вузол і чотири сусідні.
const Network = () => (
  <>
    <circle cx="32" cy="32" r="7" />
    <circle cx="11" cy="13" r="5" />
    <circle cx="53" cy="13" r="5" />
    <circle cx="11" cy="51" r="5" />
    <circle cx="53" cy="51" r="5" />
    <path d="M15 17l12 10M49 17 37 27M15 47l12-10M49 47 37 37" />
  </>
);

// 04. Дистанційно по всій Україні — позначка на мапі й сигнал над нею.
const Remote = () => (
  <>
    <path d="M26 58S10 43 10 29a16 16 0 0 1 32 0c0 14-16 29-16 29Z" />
    <circle cx="26" cy="29" r="6" />
    <path d="M44 14a10 10 0 0 1 7 7M47 7a17 17 0 0 1 11 11" />
  </>
);

// 05. Кажемо, коли послуга не потрібна — чесна відповідь у розмові.
const Advice = () => (
  <>
    <path d="M12 10h40a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H28L16 54V42h-4a4 4 0 0 1-4-4V14a4 4 0 0 1 4-4Z" />
    <path d="m23 27 6 6 12-12" />
  </>
);

const GLYPHS = [Focus, Chain, Network, Remote, Advice];

const AdvantageGlyph = ({ index, className = 'w-10 h-10' }) => {
  const Glyph = GLYPHS[index] || GLYPHS[0];
  return (
    <Frame className={className}>
      <Glyph />
    </Frame>
  );
};

export default AdvantageGlyph;
